import React from "react";

export const Separator = (): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 312 1"
            fill="none"
            preserveAspectRatio="none"
            style={{ width: "100%", height: "1px", display: "block" }}
        >
            <path d="M0 0.5H312" stroke="#02060C" strokeOpacity={0.15} strokeDasharray="2 3" />
        </svg>
    );
};
